// components/IntroBlock.jsx
import { useMemo } from "react";
import { getRandomVariant } from "./getRandomVariant";

const introVariants = [
  ({ company, sector }) => (
    <>
      <strong>{company}</strong> operates in the <strong>{sector}</strong> sector and is actively tracked for its financial performance and fundamentals. Key financial ratios help in understanding valuation, profitability, efficiency, liquidity, and
      capital structure.
    </>
  ),

  ({ company, sector }) => (
    <>
      <strong>{company}</strong> operates in the <strong>{sector}</strong> sector.  Analysing <strong>{company}</strong> involves reviewing financial ratios to understand revenue trends, balance sheet structure, and operational performance over time.
    </>
  ),

  ({ company, sector }) => (
    <>
      <strong>{company}</strong> operates in the <strong>{sector}</strong> sector.  Financial ratio analysis of <strong>{company}</strong> offers insights into how the company generates income, manages resources, and finances its operations.
    </>
  )
];

export default function IntroBlock({ company, sector }) {
  const Variant = useMemo(
    () => getRandomVariant(introVariants),
    []
  );

  return (
    <p className="mb-5">
      <Variant company={company} sector={sector} />
    </p>
  );
}
